import { render, staticRenderFns } from "./CreateTemplateForm.vue?vue&type=template&id=21209390&"
import script from "./CreateTemplateForm.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports